import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Card, Button } from 'react-bootstrap';
export default function Dashboard() {
  return <Container className="text-start">
    <h1 className="mb-4">Door Studio</h1>
    <Card><Card.Body className="p-4">
      <Card.Title>Design your doors</Card.Title>
      <Card.Text>Edit openings, grooves, profiles, colours and lighting. Saved designs are private until you publish them.</Card.Text>
      <div className="d-flex flex-wrap gap-2">
        <Button as={Link} to="/dev/door-leaf">Open Door Studio</Button>
        <Button as={Link} to="/configurator" variant="outline-secondary">Public configurator</Button>
      </div>
    </Card.Body></Card>
  </Container>;
}
